export default __webpack_public_path__ + "static/media/NoDataFoundNew.379d9853.svg";